import React from 'react';
import { makeStyles, ListItemText, ListItemIcon } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { Link } from '@backstage/core-components';
import { HighlightedSearchResultText } from '@backstage/plugin-search-react';

const useStyles = makeStyles({
  flexContainer: {
    flexWrap: "wrap"
  },
  itemText: {
    width: "100%",
    marginBottom: "1rem"
  }
});
const TechDocsSearchResultListItem = (props) => {
  const {
    result,
    highlight,
    lineClamp = 5,
    asListItem = true,
    asLink = true,
    title,
    icon
  } = props;
  const classes = useStyles();
  const LinkWrapper = ({ children }) => asLink ? /* @__PURE__ */ React.createElement(Link, { noTrack: true, to: result.location }, children) : /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  const TextItem = () => {
    const resultTitle = (highlight == null ? void 0 : highlight.fields.title) ? /* @__PURE__ */ React.createElement(
      HighlightedSearchResultText,
      {
        text: highlight.fields.title,
        preTag: highlight.preTag,
        postTag: highlight.postTag
      }
    ) : result.title;
    const entityTitle = (highlight == null ? void 0 : highlight.fields.entityTitle) ? /* @__PURE__ */ React.createElement(
      HighlightedSearchResultText,
      {
        text: highlight.fields.entityTitle,
        preTag: highlight.preTag,
        postTag: highlight.postTag
      }
    ) : result.entityTitle;
    const resultName = (highlight == null ? void 0 : highlight.fields.name) ? /* @__PURE__ */ React.createElement(
      HighlightedSearchResultText,
      {
        text: highlight.fields.name,
        preTag: highlight.preTag,
        postTag: highlight.postTag
      }
    ) : result.name;
    if (!result)
      return null;
    return /* @__PURE__ */ React.createElement(
      ListItemText,
      {
        className: classes.itemText,
        primaryTypographyProps: { variant: "h6" },
        primary: /* @__PURE__ */ React.createElement(LinkWrapper, null, title ? title : /* @__PURE__ */ React.createElement(React.Fragment, null, resultTitle, " | ", entityTitle != null ? entityTitle : resultName, " docs")),
        secondary: /* @__PURE__ */ React.createElement(
          Typography,
          {
            component: "span",
            style: {
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: lineClamp,
              overflow: "hidden"
            },
            color: "textSecondary",
            variant: "body2"
          },
          (highlight == null ? void 0 : highlight.fields.text) ? /* @__PURE__ */ React.createElement(
            HighlightedSearchResultText,
            {
              text: highlight.fields.text,
              preTag: highlight.preTag,
              postTag: highlight.postTag
            }
          ) : result.text
        )
      }
    );
  };
  const ListItemWrapper = ({ children }) => asListItem ? /* @__PURE__ */ React.createElement(React.Fragment, null, icon && /* @__PURE__ */ React.createElement(ListItemIcon, null, typeof icon === "function" ? icon(result) : icon), /* @__PURE__ */ React.createElement("div", { className: classes.flexContainer }, children)) : /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  return /* @__PURE__ */ React.createElement(ListItemWrapper, null, /* @__PURE__ */ React.createElement(TextItem, null));
};

export { TechDocsSearchResultListItem };
//# sourceMappingURL=TechDocsSearchResultListItem-4736f829.esm.js.map
